import { GET_ALL_CATEGORIES } from "../../graphql/queries/categories";

let _gtmLoaded = false;
const DEFAULT_GTM_DATA = {
  origin: "aqar_web",
};

/*
 * initialData: {object} any initial data properties to send to GTM
 * containerID: {string} the container id to use for GTMd
 */
export function initializeGA4(initialData, containerID) {
  // eslint-disable-next-line no-console
  console.log("LOADING GA4 SCRIPTS");
  if (typeof window === "undefined" || _gtmLoaded) {
    return;
  }
  window.dataLayer = window.dataLayer || [];

  if (Array.isArray(initialData)) {
    window.dataLayer.unshift(...initialData);
  } else if (typeof initialData === "object") {
    window.dataLayer.unshift(initialData);
  }

  window.dataLayer.unshift(DEFAULT_GTM_DATA);

  /*eslint-disable */
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", containerID);
  /* eslint-enable */

  _gtmLoaded = true;
}

export const trackGA4Event = (event) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
};

export const formatListingSearchFilters = (whereFilters) => {
  switch (true) {
    case whereFilters?.unverified_owner?.eq === 1:
      return { poster_category_type: "owner" };
    case whereFilters?.verified_owner?.eq === 1:
      return { poster_category_type: "verified_owner" };
    case whereFilters?.direct_from_owners?.eq === 1:
      return { poster_category_type: "direct_from_owners" };
    case whereFilters?.unique_listing?.eq === 1:
      return { poster_category_type: "unique_listing" };
    default:
      return { poster_category_type: "all" };
  }
};

const idNameMap = {};
let categoriesFromCache;

const getCategoryNameFromID = (apolloClient, id) => {
  if (idNameMap[id]) {
    return idNameMap[id];
  }

  if (!categoriesFromCache) {
    const { Web } =
      apolloClient.readQuery({
        query: GET_ALL_CATEGORIES,
        variables: { lang: "ar" },
      }) || {};
    categoriesFromCache = Web?.categories;
  }

  const name = categoriesFromCache?.find(
    ({ id: categoryID }) => id === categoryID
  )?.name;
  idNameMap[id] = name;
  return name;
};

const listingFields = [
  "id",
  "category_id",
  "category_name",
  "title",
  "city_id",
  "city_name",
  "district_id",
  "district_name",
  "price",
];

export const formatListing = (listing, apolloClient) => {
  const prefix = "listing_";
  const extensibleListing = {
    ...listing,
    category_name: getCategoryNameFromID(apolloClient, listing.category),
  };

  return Object.entries(extensibleListing).reduce((acc, [key, value]) => {
    switch (key) {
      case "category":
        key = "category_id";
        break;
      case "city":
        key = "city_name";
        break;
      case "district":
        key = "district_name";
        break;
      default:
        break;
    }

    if (listingFields.includes(key)) {
      const prefixedKey = `${prefix}${key}`;
      acc[prefixedKey] = value;
    }
    return acc;
  }, {});
};
